import { fetchCommunicationUsers } from '../../../routines/integrations/communicationRoutines';

const initialState = {
  userProperties: [],
  propertyFetchLoading: true,
  error: false,
};

const communicationPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCommunicationUsers.TRIGGER: {
      return {
        ...state,
        propertyFetchLoading: true,
        error: null,
      };
    }

    case fetchCommunicationUsers.SUCCESS: {
      const userList = action.payload;
      const usersWithEmail = userList.filter((user) => user.email);

      return {
        ...state,
        propertyFetchLoading: false,
        userProperties: usersWithEmail,
      };
    }
    case fetchCommunicationUsers.FAILURE:
      return {
        ...state,
        propertyFetchLoading: false,
      };

    default:
      return state;
  }
};

export default communicationPropertyReducer;
